import React, { useState, useEffect } from 'react';
import { FiMenu, FiX, FiPhone, FiFacebook } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Success Stories', href: '#gallery' },
    { name: 'Contact', href: '#contact' },
  ];

  const facebookUrl = "https://www.facebook.com/share/1CcMBE2nDA/";

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-1' : 'bg-white/95 py-3'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-12 md:h-14">
          {/* Logo Section */}
          <div className="flex-shrink-0 flex items-center">
            <a href="#home" className="flex items-center">
              <img 
                src="https://i.postimg.cc/4ymm6Lnt/CRoss.png" 
                alt="Crossroads Driving School" 
                className="h-8 md:h-10 w-auto object-contain transition-transform duration-300 hover:scale-105"
              />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href} 
                className="text-royal font-bold hover:text-brandOrange transition-colors text-sm uppercase tracking-wider"
              >
                {link.name}
              </a>
            ))}
            
            <div className="flex items-center gap-3 ml-4">
              <a 
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-royal hover:text-brandOrange transition-colors p-2"
                aria-label="Facebook"
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a 
                href="tel:07824448455" 
                className="flex items-center gap-2 bg-royal text-white px-5 py-2.5 rounded-xl font-bold hover:bg-brandOrange transition-all shadow-md hover:shadow-xl active:scale-95 text-sm"
              >
                <SafeIcon icon={FiPhone} />
                07824 448455
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4">
            <a 
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-royal p-2"
            >
              <SafeIcon icon={FiFacebook} className="w-6 h-6" />
            </a>
            <button 
              onClick={() => setIsOpen(!isOpen)} 
              className="text-royal focus:outline-none p-2 rounded-lg bg-gray-50 border border-gray-100"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-2xl absolute w-full left-0">
          <div className="px-4 pt-4 pb-10 space-y-2">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href} 
                onClick={() => setIsOpen(false)}
                className="block px-4 py-4 text-lg font-bold text-royal hover:text-brandOrange hover:bg-gray-50 rounded-xl transition-all"
              >
                {link.name}
              </a>
            ))}
            <div className="pt-6 px-4 space-y-4">
              <a 
                href="tel:07824448455" 
                className="flex justify-center items-center gap-3 w-full bg-brandOrange text-white px-6 py-4 rounded-2xl font-bold text-xl shadow-lg"
              >
                <SafeIcon icon={FiPhone} className="w-6 h-6" />
                Call 07824 448455
              </a>
              <a 
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center items-center gap-3 w-full bg-[#1877F2] text-white px-6 py-4 rounded-2xl font-bold text-xl shadow-lg"
              >
                <SafeIcon icon={FiFacebook} className="w-6 h-6" />
                Follow on Facebook
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;